import gql from 'graphql-tag'

const OPEN_MODAL = gql`
  {
    accountMerchantModal @client
  }
`
export default OPEN_MODAL
